/**
 * Hilfs-Funktionen fuer PropertyInsightsPage — extrahiert um die Page-Komposition
 * unter 150 Zeilen zu halten.
 */
import type { BookingResponse } from '@/shared/api';

export function filterBookingsForPeriod(
  all: BookingResponse[],
  propertyId: string,
  from: string | undefined,
  to: string | undefined,
): BookingResponse[] {
  if (!from || !to) return [];
  return all.filter(
    (b) =>
      b.propertyId === propertyId &&
      b.checkInDate <= to &&
      b.checkOutDate > from &&
      b.totalPrice !== null &&
      (b.source !== 'Ota' || (b.priceEvidenceState ?? 'Known') === 'Known'),
  );
}
